import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import gfglogo from "../assets/images/logoq.png";

export default function AppHeader(){
    return (
        <Navbar bg="primary" expand="lg">
        <Container>
          <Navbar.Brand href="#home">
          <img
                            src={gfglogo}
                            width="140"
                            height="140"
                            className="d-inline-block align-top"
                            alt="React Bootstrap logo"
                        />
          </Navbar.Brand>
          <Navbar.Toggle aria-controls="basic-navbar-nav" />
          <Navbar.Collapse id="basic-navbar-nav">
            <Nav className="me-auto">
              <Nav.Link href="#home">Inicio</Nav.Link>
              <Nav.Link href="#about">Equipo</Nav.Link>
              <Nav.Link href="#services">Servicios</Nav.Link>
              <Nav.Link href="#contact">Contacto</Nav.Link>
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>
    )
}